module.exports = __webpack_public_path__ + "assets/normal/images/cloud_bg_gray.bb4332e6.png";